// 认证相关工具函数

// 检查token是否过期
export const isTokenExpired = (token: string): boolean => {
  try {
    // 解析JWT token的payload部分
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    
    return payload.exp ? payload.exp < currentTime : false;
  } catch (error) {
    // 如果解析失败，认为token无效
    return true;
  }
};

// 从token中获取用户ID
export const getUserIdFromToken = (token: string): number | null => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.user_id || payload.id || null;
  } catch (error) {
    return null;
  }
};

// 格式化用户显示名称
export const formatUserDisplayName = (user: {
  username: string;
  is_doctor: boolean;
}): string => {
  return user.is_doctor ? `${user.username} 医生` : user.username;
};

// 检查用户权限
export const hasPermission = (user: { is_doctor: boolean }, requiredRole: 'doctor' | 'user'): boolean => {
  if (requiredRole === 'doctor') {
    return user.is_doctor;
  }
  return true; // 普通用户权限所有人都有
};

export default {
  isTokenExpired,
  getUserIdFromToken,
  formatUserDisplayName,
  hasPermission,
}; 